import React from 'react';
import JRLogo from './JRLogo';

/**
 * JR Logo with Text Component
 * Logo在左侧，文字在右侧
 */
export default function JRLogoWithText({ 
  logoSize = 50, 
  color = '#1e40af',
  showText = true 
}: { 
  logoSize?: number; 
  color?: string;
  showText?: boolean;
}) {
  return (
    <div className="flex items-center space-x-3">
      {/* Logo */}
      <JRLogo size={logoSize} color={color} />
      
      {/* Text on the right */}
      {showText && (
        <div className="flex flex-col">
          <div 
            className="font-bold tracking-wide" 
            style={{ 
              fontSize: '16px', 
              letterSpacing: '0.02em',
              background: 'linear-gradient(to right, #14b8a6, #10b981)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              lineHeight: '1.3'
            }}
          >
            JRwiki Insight
          </div>
          <div 
            className="text-xs tracking-wide" 
            style={{ 
              fontSize: '11px', 
              letterSpacing: '0.02em',
              color: '#9ca3af',
              lineHeight: '1.3'
            }}
          >
            Quant Platform
          </div>
        </div>
      )}
    </div>
  );
}

